import React, { useEffect, useState } from 'react'
import {
	ContainerWrapper,
	HeaderWrapper,
	LenskartLogo,
	LogoWrapper,
} from './style'
import SubHeadingInfo from '../../components/SubHeadingInfo'
import ExclusiveOffers from '../../components/ExclusiveOffers'
import OfferBanners from '../../components/OfferBanners'
import { setWindowGA } from '../../helpers/DTM'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../../redux/store'
import { useTransition, animated } from 'react-spring'
import { GA, endPoints } from '../../constants'
import { getOffersJSON } from '../../redux/slices/offers'
import { APIMethods, ReqBodyWithoutHeaders } from '../../types/state'
import { Loader } from '../../styles/Loader'

const Offers = () => {
	const userDetails = useSelector((state: RootState) => state.user)
	const metaData = useSelector((state: RootState) => state.meta)
	const voteData = useSelector((state: RootState) => state.votes)
	const data = useSelector((state: RootState) => state.offers)
	const [isLoaded, setIsLoaded] = useState(false)
	const dispatch = useDispatch()

	const {
		VOTES_SUBMITTED,
		VOTES_CLOSED,
		CLOSED_SUB_HEADING,
		SUB_HEADING,
		EXCLUSIVE_OFFER,
		OFFER_BANNER,
		LENSKART_LOGO,
		SHOW_OFFERS,
		VOTED_ALREADY,
		VOTED_ALREADY_SUB_HEADING,
	} = data
	const votingAvailable = metaData.votingClose

	const transition = useTransition(isLoaded, {
		from: { x: 0, y: 950, opacity: 0, delay: 650 },
		enter: { x: 0, y: 0, opacity: 1, delay: 650 },
		leave: { x: 0, y: 950, opacity: 0, delay: 650 },
	})

	useEffect(() => {
		setIsLoaded(true)
		const reqObj: ReqBodyWithoutHeaders = {
			method: APIMethods.GET,
			url: endPoints.offersJSON,
			client: metaData.deviceType,
		}
		dispatch(getOffersJSON(reqObj))
	}, [dispatch, metaData.deviceType])

	useEffect(() => {
		setWindowGA({
			event: GA.eventName,
			pageName: votingAvailable
				? GA.votingClosedPage
				: voteData.alreadyParticipated
				? GA.alreadySubmitted
				: GA.thankYouPage,
			mobile: btoa(userDetails.phone.toString()),
			pageURL: window.location.href + '/offers',
			customerID: userDetails.id,
			lkUserType: userDetails.hasPlacedOrder ? 'lkRepeat' : 'lkNew',
			loginStatus: metaData.isLogin,
			platform: metaData.platform,
		})
		window.clevertap.event.push('Pages Viewed', {
			'Page Name': votingAvailable
				? GA.votingClosedPage
				: voteData.alreadyParticipated
				? GA.alreadySubmitted
				: GA.thankYouPage,
			Phone: userDetails.phone,
		})
	}, [metaData.isLogin, metaData.platform, userDetails, votingAvailable])

	return (
		<>
			{transition((style, item) =>
				item ? (
					<animated.div style={style}>
						<ContainerWrapper platform={metaData.platform}>
							<HeaderWrapper>
								{votingAvailable
									? VOTES_CLOSED
									: voteData.alreadyParticipated
									? VOTED_ALREADY
									: VOTES_SUBMITTED}
							</HeaderWrapper>
							<SubHeadingInfo
								votingAvailable={votingAvailable}
								alreadyParticipated={voteData.alreadyParticipated}
								SUB_HEADING={SUB_HEADING}
								CLOSED_SUB_HEADING={CLOSED_SUB_HEADING}
								VOTED_ALREADY_SUB_HEADING={VOTED_ALREADY_SUB_HEADING}
							/>
							<LogoWrapper>
								<div style={{ width: '50%', marginRight: '20px' }}>
									<LenskartLogo src={LENSKART_LOGO} />
								</div>
							</LogoWrapper>
							{SHOW_OFFERS && (
								<ExclusiveOffers EXCLUSIVE_OFFER={EXCLUSIVE_OFFER} />
							)}
						</ContainerWrapper>
						<OfferBanners
							OFFER_BANNER={OFFER_BANNER}
							votingAvailable={votingAvailable}
							alreadyParticipated={voteData.alreadyParticipated}
							phoneNo={userDetails.phone}
						/>
					</animated.div>
				) : (
					<Loader />
				)
			)}
		</>
	)
}

export default Offers
